import { useEffect, useState } from "react"
import {
  readCachedWebsiteContent,
  refreshWebsiteContent,
  websiteCmsEnabled,
} from "../services/websiteCms"

export default function useWebsiteCmsContent() {
  const [payload, setPayload] = useState(null)

  useEffect(() => {
    if (!websiteCmsEnabled()) return undefined

    const cached = readCachedWebsiteContent()
    if (cached) setPayload(cached)

    let active = true
    refreshWebsiteContent()
      .then(next => {
        if (active && next) setPayload(next)
      })
      .catch(() => {})

    return () => {
      active = false
    }
  }, [])

  return payload
}
